import { createSelector } from '@reduxjs/toolkit';
import { entries, sortBy, toNumber } from 'lodash';
import { selectTabs, selectWindows, Window } from './windowsSlice';
import { selectSelectedUrls } from './uiSlice';

export const selectWindowsSortedExcept = createSelector(
  [selectWindows, (state, exceptWindowId: number | undefined) => exceptWindowId],
  (windows, exceptWindowId) => {
    const x = sortBy(Object.entries(windows), (a) => -a[1].accessTime);
    const y = x.map(([s, w]) => [toNumber(s), w]).filter(([s, w]) => exceptWindowId === undefined || s !== exceptWindowId) as [
      number,
      Window
    ][];
    return y;
  }
);

export const selectSelectedTabs = createSelector(
  selectSelectedUrls,
  selectTabs,
  (selectedUrls, tabs) => {
    const selectedTabs = entries(tabs)
      .filter(
        ([tabId, tab]) =>
          tab != null && tab.url != null && selectedUrls.includes(tab.url.normalized)
      )
      .map(([tabId, tab]) => tab);
    return selectedTabs;
  }
);
